var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"lightrope"},_vm._l((_vm.currentBulbsCount),function(n){return _c('li',{key:n})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }